<div class="w-full h-full flex flex-col">
    @if(showHeader){
    <h2 class="font-bold mb-4">{{'Milestones' | textCase}}</h2>
    }
    <!-- Add button -->
    @if(permissions.canEdit){
    <div class="flex-shrink-0 mb-4">
        <app-button label="{{'Add Milestone' | textCase}}" icon="pi pi-plus" variant="filled" severity="primary"
            (clicked)="addMilestone()" />
    </div>
    }
    <!-- Scrollable milestone list -->
    <div class="flex-1 overflow-y-auto">
        <div class="flex flex-col gap-4">
            <div *ngFor="let m of editableMilestones(); let i = index" class="relative">
                <div class="flex justify-between items-center gap-2 py-1">
                    <!-- Name -->
                    <input type="text" [(ngModel)]="m.name" (ngModelChange)="emitMilestonesChange()"
                        class="text-sm border rounded-base flex-1 p-2 max-w-full"
                        placeholder="{{'Milestone name' | textCase}}" [readonly]="!permissions.canEdit" />

                    <!-- Due Date -->
                    <!-- <p-calendar [(ngModel)]="m.date" (onSelect)="emitMilestonesChange()" [showIcon]="true"
                        dateFormat="dd/mm/yy" placeholder="Select Due Date" [minDate]="minDateForDueDate"
                        appendTo="body" class="w-40 rounded-base border p-2 calendar"></p-calendar> -->
                    <div class="flex items-center gap-2">
                        <div class="flex flex-col w-[18rem]">
                            <app-datepicker [(value)]="$any(m.date)" [config]="{
                                showIcon: true,
                                dateFormat: 'dd/mm/yy',
                                placeholder: 'Select Due Date',
                                minDate: minDateForDueDate,
                                maxDate: maxMilestoneDueDateAsDate,
                                showTime: false,
                                appendTo: 'body',
                                keepInvalid: true,
                                disabled: !permissions.canEdit
                            }" (onSelect)="onDueDateChange(i)" />
                        </div>


                        <!-- Notify options -->
                        @if(permissions.canEdit){
                        <app-button variant="outlined" severity="contrast"
                            [label]="getCustomizeReminderLabel() | textCase"
                            (clicked)="openCustomNotificationPanel($event, i)"
                            [icon]="m.reminder ? 'pi pi-clock' : 'pi pi-plus'" />
                        }

                        <!-- Delete -->
                        @if(permissions.canEdit){
                        <app-button icon="pi pi-trash" variant="outlined" severity="danger"
                            (clicked)="deleteMilestone(i)" />
                        }
                    </div>
                </div>

                <!-- Show effective reminder -->
                <div *ngIf="m.reminder">
                    <span class="text-xs italic text-gray-600">
                        {{'Reminder on' | textCase}} {{ m.reminder.date | date:'dd/MM/yyyy' }}, {{ m.reminder.time |
                        date:'h:mm a' }}
                    </span>
                    <span class="text-xs italic text-gray-600">
                        @if(m.reminder.repeat.option){
                        {{'Repeat:' | textCase}} {{ m.reminder.repeat.option }}
                        }
                        @if(m.reminder.repeat.frequency){
                        | {{ m.reminder.repeat.frequency }}
                        }
                        @if(m.reminder.repeat.unit){
                        | {{ m.reminder.repeat.unit }}
                        }
                        @if(m.reminder.repeat.weekDays?.join(', ')){
                        | {{ m.reminder.repeat.weekDays?.join(', ') }}
                        }
                    </span>
                    @if(m.reminder.deliveryChannels.email || m.reminder.deliveryChannels.inApp){
                    <span class="text-xs italic text-gray-600">
                        | {{'Notification channels:' | textCase}} {{ m.reminder.deliveryChannels.email ? 'Email' : '' }}
                        | {{
                        m.reminder.deliveryChannels.inApp ? 'In App' : '' }}
                    </span>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="flex gap-2 justify-between pt-4">
        <div class="flex gap-2" *ngIf="showActions">
            <app-button label="{{'Cancel' | textCase}}" variant="outlined" severity="contrast" (clicked)="onCancel()" />
            @if(permissions.canEdit){
            <app-button label="{{'Save' | textCase}}" icon="pi pi-save" variant="filled" severity="primary"
                (clicked)="onSave()" />
            }
        </div>
    </div>
</div>

<app-dialog [(visible)]="showCustomDialog" [title]="getCustomizeReminderHeader() | textCase"
    (closed)="showCustomDialog = false" [fullscreenOnMobile]="true"
    [class]="!pickCustomDateReminderToggle ? 'max-w-[900px]' : 'max-w-[500px]'">
    <ng-template #bodyTemplate>

        <div class="flex flex-col gap-4 p-2 h-full">
            <div class="flex flex-col gap-4">
                <div class="flex flex-col gap-2">
                    <label class="text-md font-medium">{{'Pick a date' | textCase}}</label>
                    <div class="flex flex-col max-w-xs">
                        <app-datepicker [(value)]="tempCustomDate" [config]="customDateReminderConfig"
                            (onSelect)="onCustomDateChange()" />
                        <small *ngIf="isReminderDateAfterMilestone()" class="text-danger text-xs mt-1">
                            {{'Reminder date cannot be after milestone due date' | textCase}}
                        </small>
                    </div>
                </div>
                <div class="flex flex-col gap-2">
                    <!-- <label class="text-md font-medium">{{'Options' | textCase}}</label> -->
                    <div class="flex flex-wrap gap-2">
                        <app-button *ngFor="let option of quickOptions" variant="outlined" severity="contrast"
                            [label]="option.label"
                            [class]="'px-3 py-1.5 text-sm rounded-base transition-colors ' + (selectedQuickOption === option.value ? 'bg-orange-100 border-orange-500' : 'hover:bg-gray-50')"
                            (clicked)="selectQuickOption(option.value)" />
                    </div>
                </div>
            </div>
            <hr>
            <div class="flex flex-col gap-3 h-full max-w-[30%]">
                <label class="text-md font-medium">{{'Time' | textCase}}</label>
                <app-datepicker [(value)]="tempCustomTime" [config]="{
                    timeOnly: true,
                    appendTo: 'body',
                    hourFormat: '24'
                }" />
            </div>

            <div class="flex flex-col gap-2">
                <div class="flex flex-row items-center gap-2  rounded-base">
                    <!-- <i class="pi pi-sync text-sm text-gray-500"></i> -->
                    <span class="text-md font-medium">{{'Repeat' | textCase}}</span>
                    <i class="pi pi-info-circle text-sm text-gray-500"
                        pTooltip="Set how often reminders should repeat after the first one until the milestone Due Date."></i>
                </div>
                <app-select [(value)]="selectedRepeatOption" [options]="repeatOptions" [config]="repeatConfig" />

                @if(selectedRepeatOption === 'custom') {
                <div class="custom-recurrence mt-4">
                    <div class="flex flex-row gap-6">
                        <!-- Repeat Frequency -->
                        <div class="flex flex-col gap-2">
                            <div class="flex items-center gap-2">
                                <span class="text-md">{{'Repeat every:' | textCase}}</span>
                                <div class="flex items-center gap-2">
                                    <input [(ngModel)]="repeatFrequency" [min]="1" type="number"
                                        class="w-full p-2 text-xs rounded-base border shadow-sm hover:bg-gray-50 cursor-pointer" />
                                </div>
                                <app-select [(value)]="repeatUnit" [options]="repeatUnits"
                                    [config]="repeatUnitsConfig" />
                            </div>

                            <!-- Week Days Selection -->
                            @if(repeatUnit === 'week') {
                            <div class="flex flex-col gap-2">
                                <span class="text-sm">{{'Repeat on:' | textCase}}</span>
                                <div class="flex gap-2">
                                    @for(day of weekDays; track day.value) {
                                    <app-button shape="circle" size="sm" [label]="day.label"
                                        [class]="'w-8 h-8 text-xs font-medium ' + (day.selected ? 'bg-orange-500 text-white' : 'bg-gray-100')"
                                        (clicked)="toggleWeekDay(day)" />
                                    }
                                </div>
                            </div>
                            }
                        </div>
                        <div class="w-[1px] bg-gray-200"></div>
                        <div class="flex flex-col gap-3">
                            <span class="text-sm font-medium">{{'Ends on:' | textCase}}</span>
                            <div class="flex flex-col gap-3">
                                @for (option of endOptions; track option.value) {
                                <div class="flex items-center gap-2">
                                    <p-radioButton name="endOptions" [value]="option.value"
                                        [(ngModel)]="selectedEndOption" [inputId]="'end_' + option.value"
                                        class="text-orange-500"></p-radioButton>

                                    <label [for]="'end_' + option.value" class="text-sm cursor-pointer">
                                        {{ option.label }}
                                    </label>

                                    @if (option.value === 'on' && selectedEndOption === 'on') {
                                    <app-datepicker [(value)]="endDate" [config]="{
                                        showIcon: true,
                                        dateFormat: 'dd/mm/yy',
                                        appendTo: 'body'
                                    }" />
                                    }

                                    @if (option.value === 'after' && selectedEndOption === 'after') {
                                    <div class="flex items-center gap-2">
                                        <input [(ngModel)]="occurrences" [min]="1" type="number"
                                            class="w-full p-2 text-xs rounded-base border shadow-sm hover:bg-gray-50 cursor-pointer" />
                                        <span class="text-sm">{{"occurrences" | titlecase}}</span>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
                }
            </div>
            <div class="flex flex-col gap-2">
                <div class="flex flex-row gap-2">
                    <!-- <i class="pi pi-bell text-sm text-gray-500"></i> -->
                    <label class="text-md font-medium">{{'Notification Channels' | textCase}}</label>
                </div>
                <div class="flex flex-row gap-6">
                    <div class="flex flex-row gap-2 items-center ">
                        <app-checkbox [(value)]="selectedNotificationChannels.email"
                            [config]="{ binary: true, inputId: 'emailNotification', label: 'Email' }"
                            (onChange)="onToggleNotificationChannels()"></app-checkbox>
                        <!-- <i class="pi pi-envelope text-sm text-gray-500"></i> -->
                    </div>
                    <div class="flex flex-row gap-2 items-center">
                        <app-checkbox [(value)]="selectedNotificationChannels.inApp"
                            [config]="{ binary: true, inputId: 'appNotification', label: 'Notifications' }"
                            (onChange)="onToggleNotificationChannels()"></app-checkbox>
                        <!-- <i class="pi pi-bell text-sm text-gray-500"></i> -->
                    </div>
                </div>

            </div>
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="flex justify-between gap-3 w-full items-center">
            <app-button label="{{'Remove Reminder' | textCase}}" [disabled]="!selectedMilestone?.reminder"
                variant="outlined" severity="danger" (clicked)="removeReminder()" />

            <div class="flex gap-2">
                <app-button label="{{'Save' | textCase}}" variant="filled" severity="primary"
                    [disabled]="!isReminderDateValid()" (clicked)="applyCustomNotification()" />
            </div>
        </div>
    </ng-template>
</app-dialog>